module.exports = __webpack_public_path__ + "img/ben_yes.565431c3.png";